
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
@Component({
  name: "AlertTriggerControls",
})
export default class AlertTriggerControls extends Vue {
  @Prop({ type: String, required: false, default: "de" })
  private readonly locale!: string;

  @Prop({ type: String, required: true })
  private readonly securityId!: string;

  protected id = "";
  @Watch("securityId", { immediate: true })
  public updateIdNotation() {
    this.id = this.securityId;
  }
  public onExchangeChange(payload: Record<string, string>): void {
    this.id = payload.id;
  }
}
